// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3OtQa","title":"ClientInsurance_title__212Sj","itemText":"ClientInsurance_itemText__CBuvN"};